import { Box, SpaceBetween } from '@cloudscape-design/components';
import { ConfigurationObject } from '../../services/configs-api';
import { resolveConfigName } from './format-utils';

interface MenuDetailProps {
  config: ConfigurationObject;
  allConfigs: ConfigurationObject[];
}

/**
 * Human-readable detail view for Menu config type.
 * Shows: Config Name, Menu Prompt, Options 1–8 (populated only) as "Option N → [Intent Name]"
 */
export function MenuDetail({ config, allConfigs }: MenuDetailProps) {
  const payload = config.payload ?? {};
  const menuPrompt = (payload.menuPrompt as string) ?? '—';

  // Collect populated options (option1Intent through option8Intent)
  const options: { num: number; intentName: string }[] = [];
  for (let i = 1; i <= 8; i++) {
    const intentId = payload[`option${i}Intent`] as string | undefined;
    if (intentId) {
      options.push({ num: i, intentName: resolveConfigName(intentId, allConfigs) });
    }
  }

  return (
    <SpaceBetween size="m">
      <div>
        <Box variant="awsui-key-label">Menu Prompt</Box>
        <Box variant="p" color="text-body-secondary">
          "{menuPrompt}"
        </Box>
      </div>

      {options.length > 0 && (
        <div>
          <Box variant="awsui-key-label">Menu Options</Box>
          <SpaceBetween size="xs">
            {options.map((opt) => (
              <div key={opt.num}>
                <strong>Option {opt.num}</strong> → {opt.intentName}
              </div>
            ))}
          </SpaceBetween>
        </div>
      )}

      {options.length === 0 && (
        <div>
          <Box variant="awsui-key-label">Menu Options</Box>
          <Box color="text-status-inactive">No options configured</Box>
        </div>
      )}
    </SpaceBetween>
  );
}
